import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CoreConfig } from 'src/app/models/core-config.model';
import { AuthService } from '../auth.service';

@Component({
  templateUrl: './server-error.component.html',
  standalone: false,
})
export class ServerErrorComponent {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {
    this.config = this.authService.getCoreConfig();
  }

  config!: CoreConfig;

  return() {
    this.router.navigate([this.config.redirectPathAfterLogin]);
  }
}
